module.exports = __webpack_public_path__ + "static/media/button-wizard-1.03263acb.png";